/* ==========================================================================
   PWR COLLECTIONS
   ----------------------------------------------------------------------------
   Section controller for "Shop By Collection".

   IMPORTANT — READ BEFORE ADDING CODE:
   This section is presentational. The requested interactions (image zoom,
   overlay darken, title lift, arrow slide) are ALL CSS :hover transforms in
   pwr-collections.css — no JavaScript drives them, and they are guarded by
   @media (hover: hover) so touch devices never get stuck states. The card
   cascade reveal is owned by the PWR Animation Engine via
   [data-pwr-reveal-group], auto-scanned on load and shopify:section:load.

   This controller therefore does NO work today — re-implementing hover or
   reveal here would duplicate CSS/the engine and violate the theme's reuse
   rules. It exists as a registered lifecycle seam so that:
     1. every section has a consistent {liquid, css, js} shape, and
     2. a hook is ready if this section later gains real behaviour (e.g. a
        draggable carousel or filtered collection switching).

   Registered via PWR.registerSection => Theme Editor safe (mount on load +
   section:load, teardown on section:unload), no duplicate init. init() is an
   intentional no-op until behaviour is needed.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.PWR || !window.PWR.registerSection) return;
  var PWR = window.PWR;
  var Section = PWR.Section;

  function Collections(root) {
    Section.call(this, root);
  }
  Collections.prototype = Object.create(Section.prototype);
  Collections.prototype.constructor = Collections;

  /* No behaviour to bind: hover is CSS, reveal is engine-owned. Intentionally
     empty. Add future interactivity here; register cleanups via addCleanup(). */
  Collections.prototype.init = function () {};

  PWR.registerSection('pwr-collections', function (root) { return new Collections(root); });
})();
